import React from "react";
import { Route, Routes } from "react-router-dom";
import Lazy from "./shared/LazyHOC";
import { UnauthenticatedTemplate } from "@azure/msal-react";

const LazyHome = Lazy(React.lazy(() => import("./containers/Home")));

const LazyNotFound = Lazy(React.lazy(() => import("./containers/NotFound")));

const LazyMarketMonitor = Lazy(React.lazy(() => import("./containers/MarketMonitor")));

const LazyActivityMonitor = Lazy(React.lazy(() => import("./containers/ActivityMonitor")));

const LazyCreditMonitor = Lazy(React.lazy(() => import("./containers/CreditMonitor")));
const LazyCreditMonitoringWorkbench = Lazy(React.lazy(() => import("./containers/CreditMonitoringWorkbench")));
const LazyCreditMonitoringCompanyWorkspace = Lazy(
  React.lazy(() => import("./containers/CreditMonitoringCompanyWorkspace")),
);

const LazyPortfolio = Lazy(React.lazy(() => import("./containers/Portfolio")));

const LazyToolsRoute = Lazy(React.lazy(() => import("./containers/ToolsRoute")));

const LazyTenantPortal = Lazy(React.lazy(() => import("./containers/TenantPortal")));

export function isProtectedRoute(pathname) {
  return /^\/(market-monitor|activity-monitor|credit-monitor|portfolio|tools)(\/|$)/.test(pathname);
}

export function preloadRoute(pathname) {
  if (/^\/credit-monitor\/workbench\/company\//.test(pathname)) {
    return import("./containers/CreditMonitoringCompanyWorkspace");
  }
  if (/^\/credit-monitor\/workbench(?:\/|$)/.test(pathname)) {
    return import("./containers/CreditMonitoringWorkbench");
  }
  if (/^\/credit-monitor(?:\/|$)/.test(pathname)) {
    return import("./containers/CreditMonitor");
  }
  if (/^\/market-monitor(?:\/|$)/.test(pathname)) {
    return import("./containers/MarketMonitor");
  }
  if (/^\/activity-monitor(?:\/|$)/.test(pathname)) {
    return import("./containers/ActivityMonitor");
  }
  if (/^\/portfolio(?:\/|$)/.test(pathname)) {
    return import("./containers/Portfolio");
  }
  if (/^\/tools(?:\/|$)/.test(pathname)) {
    return import("./containers/ToolsRoute");
  }

  return Promise.resolve();
}

function RouterRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LazyHome />} />

      <Route path="*" element={<LazyNotFound />} />

      <Route
        path="/tenant-portal/:key"
        element={
          <UnauthenticatedTemplate>
            <LazyTenantPortal />
          </UnauthenticatedTemplate>
        }
      />

      <Route path="/market-monitor/:view" element={<LazyMarketMonitor />} />
      <Route path="/market-monitor/:view/:parsekey" element={<LazyMarketMonitor />} />

      <Route path="/activity-monitor/:view" element={<LazyActivityMonitor />} />

      <Route path="/credit-monitor/workbench" element={<LazyCreditMonitoringWorkbench />} />
      <Route path="/credit-monitor/workbench/:friendlyEntityId" element={<LazyCreditMonitoringCompanyWorkspace />} />

      <Route path="/credit-monitor/:view" element={<LazyCreditMonitor />} />
      <Route path="/credit-monitor/:view/:parsekey" element={<LazyCreditMonitor />} />

      <Route path="/portfolio/:view" element={<LazyPortfolio />} />

      <Route path="/tools" element={<LazyToolsRoute />} />
      <Route path="/tools/:view" element={<LazyToolsRoute />} />
    </Routes>
  );
}

export default RouterRoutes;
